import React from 'react';
import PropTypes from 'prop-types';
import { VelocityComponent } from 'velocity-react';
import { DURATION_DROPDOWN_TOGGLE } from './util';

export const fadeInDown = show => (show ? { opacity: 1, translateY: '0px' } : { opacity: 0, translateY: '-10px' });

const VelocityDropdown = ({ show, containerClasses, contentClasses, duration, children }) => (
  <VelocityComponent animation={show ? 'slideDown' : 'slideUp'} duration={duration}>
    <section className={containerClasses}>
      <VelocityComponent animation={fadeInDown(show)} duration={duration} delay={show ? duration : 0}>
        <div className={contentClasses}>{children}</div>
      </VelocityComponent>
    </section>
  </VelocityComponent>
);

VelocityDropdown.defaultProps = {
  containerClasses: '',
  contentClasses: '',
  duration: DURATION_DROPDOWN_TOGGLE
};

VelocityDropdown.propTypes = {
  show: PropTypes.bool.isRequired,
  duration: PropTypes.number,
  containerClasses: PropTypes.string,
  contentClasses: PropTypes.string,
  children: PropTypes.node.isRequired
};

export default VelocityDropdown;
